export type QuoteBehaviour = 'optional' | 'auto' | 'mandatory';

interface QuoteBehaviourFlags {
    auto_include: boolean;
    mandatory: boolean;
}

export interface QuoteBehaviourOption {
    value: QuoteBehaviour;
    label: string;
    help: string;
}

export const QUOTE_BEHAVIOUR_OPTIONS: QuoteBehaviourOption[] = [
    { value: 'optional', label: 'Optional', help: 'Seller adds it from the catalogue.' },
    { value: 'auto', label: 'Auto-included', help: 'Added to every quote, seller may remove it.' },
    { value: 'mandatory', label: 'Mandatory', help: 'Added to every quote and locked.' },
];

/** Derives the three-way choice from the stored `auto_include`/`mandatory` booleans. */
export function toQuoteBehaviour({ auto_include, mandatory }: QuoteBehaviourFlags): QuoteBehaviour {
    if (mandatory) return 'mandatory';
    if (auto_include) return 'auto';
    return 'optional';
}

/** Writes the choice back to the two booleans the schema and payload still carry. */
export function fromQuoteBehaviour(value: QuoteBehaviour): QuoteBehaviourFlags {
    if (value === 'mandatory') return { auto_include: true, mandatory: true };
    if (value === 'auto') return { auto_include: true, mandatory: false };
    return { auto_include: false, mandatory: false };
}
